import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatSort, MatTableDataSource } from '@angular/material';
import { StatusService } from '../../../services/status.service';
import { Status } from '../../../interfaces/status';
import { ToastsManager } from 'ng2-toastr';
import { LoggerService } from '../../../services/logger.service';
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { filter, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-status-list',
  templateUrl: './status-list.component.html',
  styleUrls: ['./status-list.component.scss']
})
export class StatusListComponent implements OnInit {
  @ViewChild(MatSort)
  sort: MatSort;

  public statuses: Status[];
  public dataSource: MatTableDataSource<Status>;
  public displayedColumns = [
    'orderNumber',
    'statusName',
    'statusCode',
    'viewableBy',
    'editableBy',
    'updated',
    'delete'
  ];
  public isLoadingResults = false;

  constructor(private statusService: StatusService, private toastr: ToastsManager, private dialog: MatDialog) {}

  ngOnInit() {
    this.isLoadingResults = true;
    this.statusService.getStatuses().subscribe(
      statuses => {
        this.statuses = statuses.sort((a, b) =>
          a.orderNumber < b.orderNumber ? -1 : a.orderNumber > b.orderNumber ? 1 : 0
        );
        this.dataSource = new MatTableDataSource(this.statuses);
        this.dataSource.sort = this.sort;
        this.isLoadingResults = false;
      },
      error => {
        LoggerService.log('StatusListComponent::ngOnInit', error);
        this.toastr.error('Problem z pobraniem danych');
      }
    );
  }

  deleteStatus(event: Event, id: string, statusName: string): void {
    event.stopPropagation();

    this.dialog
      .open(ConfirmationDialogComponent, {
        data: {
          title: 'STATUS_LIST.DELETE_DIALOG.TITLE',
          body: 'STATUS_LIST.DELETE_DIALOG.BODY',
          translateParams: { statusName }
        }
      })
      .afterClosed()
      .pipe(
        filter(v => v),
        switchMap(() => this.statusService.deleteStatus(id))
      )
      .subscribe(
        () => {
          this.statuses = this.statuses
            .filter(status => status._id !== id)
            .sort((a, b) => (a.orderNumber < b.orderNumber ? -1 : a.orderNumber > b.orderNumber ? 1 : 0));
          this.dataSource = new MatTableDataSource(this.statuses);
          this.toastr.success('Usunięto status z listy.', 'Sukces!');
        },
        error => {
          LoggerService.log('StatusListComponent::deleteStatus', error);
          this.toastr.error('Problem z usunięciem statusu z listy');
        }
      );
  }

  moveUp(event: Event, index: number, id: string): void {
    event.stopPropagation();
    LoggerService.log(`StatusListComponent::${id} with index ${index} is moving up`);
    const prev = this.statuses[index - 1];
    const curr = this.statuses[index];

    this.statuses[index - 1] = curr;
    this.statuses[index] = prev;

    this.dataSource = new MatTableDataSource(this.statuses);
  }

  moveDown(event: Event, index: number, id: string): void {
    event.stopPropagation();
    LoggerService.log(`StatusListComponent::${id}  with index ${index} is moving down`);

    const next = this.statuses[index + 1];
    const curr = this.statuses[index];

    this.statuses[index + 1] = curr;
    this.statuses[index] = next;

    this.dataSource = new MatTableDataSource(this.statuses);
  }

  saveOrder(event: Event): void {
    event.stopPropagation();

    for (const index in this.statuses) {
      if (!this.statuses.hasOwnProperty(index)) {
        continue;
      }
      const numericIndex = +index;
      const status = this.statuses[numericIndex];
      if (status.orderNumber !== numericIndex) {
        LoggerService.log('StatusListComponent::saveOrder:', status);
        status.orderNumber = numericIndex;
        this.statusService
          .updateStatus(status._id, status)
          .subscribe(saved => LoggerService.log('StatusListComponent::saveOrder::saved successfuly', saved));
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/lifecycle/status-list/status-list.component.ts